import React from 'react'
import { FlatList, StyleSheet, View } from 'react-native'
import { useTheme } from '@react-navigation/native'
import { Theme } from '@theme'
import type { ScrapedProfile } from '@hooks'
import { ScrapedProfileItem } from './ScrapedProfileItem'

interface ScrapedProfilesListProps {
  profiles: ScrapedProfile[]
  selectedIds: Set<number>
  onToggle: (index: number) => void
  disabledUsernames?: Set<string>
}

export const ScrapedProfilesList = ({ profiles, selectedIds, onToggle, disabledUsernames }: ScrapedProfilesListProps) => {
  const theme = useTheme()
  const styles = getStyles(theme)

  return (
    <FlatList
      data={profiles}
      keyExtractor={(_, index) => index.toString()}
      renderItem={({ item, index }) => {
        const isDisabled = !!(disabledUsernames && item.username && disabledUsernames.has(item.username))
        return (
          <ScrapedProfileItem
            profile={item}
            isSelected={selectedIds.has(index)}
            onToggle={() => onToggle(index)}
            disabled={isDisabled}
          />
        )
      }}
      ItemSeparatorComponent={() => <View style={styles.separator} />}
      style={styles.list}
      contentContainerStyle={styles.listContent}
    />
  )
}

const getStyles = (theme: Theme) =>
  StyleSheet.create({
    list: {
      flex: 1,
    },
    listContent: {
      paddingBottom: theme.spacing.lg,
    },
    separator: {
      height: 1,
      backgroundColor: theme.colors.grey,
      marginHorizontal: theme.spacing.md,
    },
  })
